import { useParams } from "react-router-dom";
import { Image } from "@chakra-ui/react";
import InputFile from "../../../../components/forms/InputFile";
import {  staticApi } from "../../../../api";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

export const UploadImage = () => {
  const { id } = useParams();

  const changeImage = async (e) => {
    const response = await staticApi.uploadImage(id, e.target.files[0]);
    console.log(response);
    if(response.data){
        toast.success("Imagen guardada correctamente", { theme: "dark" });
    }
  };

  const [variant, setVariant] = useState({});
  
    useEffect(() => {
      staticApi.show(id).then((res) => {
        setVariant(res.data.data);
      });
    }, [id, setVariant]);

  return (
    <>
      <Image
        boxSize="200px"
        style={{ margin: "1rem auto" }}
        src={
          variant?.image === "null"
            ? "https://cdn-icons-png.flaticon.com/512/149/149071.png"
            : variant?.image
        }
      ></Image>
      <InputFile
        accept={["image/png", "image/gif", "image/jpeg", "image/webp"]}
        onChange={changeImage}
      />
    </>
  );
};
